var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8 3 A 1.0001 1.0001 0 0 0 7 4 L 7 10 L 1 10 C 0.45 10 0 10.45 0 11 L 0 18 C 0 18.55 0.45 19 1 19 L 2.5605469 19 C 3.2568565 20.187528 4.5333802 21 6 21 C 7.4666198 21 8.7431435 20.187528 9.4394531 19 L 14.560547 19 C 15.256857 20.187528 16.53338 21 18 21 C 19.46662 21 20.743143 20.187528 21.439453 19 L 23 19 C 23.55 19 24 18.55 24 18 L 24 12.820312 C 24 11.870312 23.320625 11.039375 22.390625 10.859375 L 18.642578 10.109375 L 14.869141 3.5039062 A 1.0001 1.0001 0 0 0 14 3 L 8 3 z M 9 5 L 13.419922 5 L 16.275391 10 L 9 10 L 9 5 z M 6 15 C 7.1164141 15 8 15.883586 8 17 C 8 18.116414 7.1164141 19 6 19 C 4.8835859 19 4 18.116414 4 17 C 4 15.883586 4.8835859 15 6 15 z M 18 15 C 19.116414 15 20 15.883586 20 17 C 20 18.116414 19.116414 19 18 19 C 16.883586 19 16 18.116414 16 17 C 16 15.883586 16.883586 15 18 15 z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.747cd08e719fb8fb355e398bd167fae0.svg";
export { ForwardRef as ReactComponent };